import type { IPlotItem } from "../../containers/PlotsContainer";
import { PlotViewerCard } from "../plots/PlotViewerCard";
import { useFullscreenPanel } from "../useFullscreenPanel";
import { OrbitSummaryCard } from "./OrbitSummaryCard";

interface OrbitPlotsPanelProps {
  orbit: unknown;
  plots: IPlotItem[];
  showSummary?: boolean;
}

export const OrbitPlotsPanel = ({
  orbit,
  plots,
  showSummary = true,
}: OrbitPlotsPanelProps) => {
  const { isFullscreen, toggleFullscreen } = useFullscreenPanel();

  return (
    <div className="h-full w-full overflow-hidden bg-slate-50/40 p-5">
      <section
        className={`grid h-full min-h-0 grid-cols-1 items-stretch gap-5 ${
          isFullscreen || !showSummary ? "" : "xl:grid-cols-[40%_minmax(0,1fr)]"
        }`}
      >
        {!isFullscreen && showSummary && <OrbitSummaryCard orbit={orbit} />}

        <PlotViewerCard
          collapsedClassName="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
          isFullscreen={isFullscreen}
          onToggleFullscreen={toggleFullscreen}
          plots={plots}
        />
      </section>
    </div>
  );
};
